import { useEffect, useState, useCallback } from 'react';
import { useApp } from '../contexts/AppContext';
// MIGRATION NOTE: apiService disabled - job restoration now handled by Convex real-time subscription in AppContext
// import { apiService } from '../services/apiService';

interface UseJobRestorationParams {
  jobId?: string;
  onJobRestored?: () => void; // Callback to clear URL params
}

export const useJobRestoration = ({ jobId, onJobRestored }: UseJobRestorationParams = {}) => {
  const { state } = useApp();
  const [hasRestoredJob] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const restoreJob = useCallback(async (jobId: string) => {
    // MIGRATION NOTE: Job restoration now handled by Convex real-time subscription in AppContext
    // This hook is deprecated and should be removed once routes are updated to use Convex directly
    console.log(`📥 Job restoration disabled - using Convex real-time subscription for job ${jobId}`);

    // No-op implementation - job status is automatically loaded via Convex subscription
    setIsLoading(false);

    // Clear URL parameter using callback
    if (onJobRestored) {
      onJobRestored();
    }
  }, [onJobRestored]);

  useEffect(() => {
    // Restore job if jobId is provided and no current job exists
    if (jobId && !state.currentJob) {
      console.log(`🔍 Found jobId: ${jobId}`);
      restoreJob(jobId);
    }
  }, [jobId, state.currentJob, restoreJob]);
  
  return {
    hasRestoredJob,
    restoredJob: state.currentJob,
    isLoading,
  };
};